import { combineReducers } from 'redux';
import { reducer as form } from 'redux-form/immutable';
import {loggedInPerson} from "./loggedInPerson";
import {general} from "./general";
import {persons} from "./persons";
import {person} from "./person";
import {roles} from "./roles";
import {departments} from "./departments";
import {pillars} from "./pillars";
import {department} from "./department";
import {pillar} from "./pillar";
import {categories} from "./categories";
import {category} from "./category";
import {criterion} from "./criterion";
import {criteria} from "./criteria";
import {stores} from "./stores";
import {scoreRecord} from "./scoreRecord";
import {scoreRecords} from "./scoreRecords";
import {LOG_OUT} from "../actions/types";
import storage from "redux-persist/es/storage";

const appReducers = combineReducers({
  form,
  scoreRecords,
  scoreRecord,
  stores,
  criteria,
  criterion,
  category,
  categories,
  pillar,
  pillars,
  department,
  departments,
  roles,
  general,
  person,
  persons,
  loggedInPerson,
});

export function createReducer(initialState, handlers) {
  return function reducer(state = initialState, action) {
    if (Object.prototype.hasOwnProperty.call(handlers, action.type)) {
      return handlers[action.type](state, action);
    }
    return state;
  };
}

const reducers = (state, action) => {
  if (action.type === LOG_OUT) {
    Object.keys(state).forEach(key => {
      storage.removeItem(`persist:rootFranchiseRankings`);
    });
    state = undefined;
  }
  return appReducers(state, action);
};

export default reducers;



// WEBPACK FOOTER //
// ./src/reducers/index.js